import feedbacksReducer from "./reducers";
export { default as feedbacksTypes } from "./types";
export { default as feedbacksOperations } from "./operations";
export default feedbacksReducer;
